export default __webpack_public_path__ + "static/media/credential-type.a44dec93.svg";